import { Close } from '@mui/icons-material';
import { Box, Theme, Typography, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@/components';
import { Modals, urls } from '@/constants';
import { AppModal } from '@/containers';
import { AnalyticsService, CPA_BUTTON_NAME } from '@/services';
import { selectSessionUserId, uiActions } from '@/store';
import { CPACanadaEpisode } from '@/types';

interface CPASignUpModalProps {
  cpaCanadaContent?: CPACanadaEpisode | null;
}

export const CPASignUpModal = ({ cpaCanadaContent }: CPASignUpModalProps) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  const isAnonymous = !useSelector(selectSessionUserId);

  if (!cpaCanadaContent) return null;

  return (
    <AppModal
      modalName={Modals.CPA_SIGNUP}
      fullScreen={isMobile}
      disableBackdropClick={true}>
      <Box
        sx={{
          border: 1,
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          px: { xs: 2, md: 6 },
          py: 6,
        }}>
        <Button
          fullWidth={false}
          startIcon={<Close />}
          skinny={false}
          variant="tertiary"
          onClick={() => {
            dispatch(uiActions.closeActiveModal());
          }}
          sx={{ position: 'absolute', top: 4, left: 4 }}
        />
        <Box>
          <Typography variant="h3" mb={4}>
            {isAnonymous
              ? cpaCanadaContent.modalEpStart.header
              : cpaCanadaContent.modalLoggedIn.header}
          </Typography>
          <Typography variant="body1">
            {isAnonymous
              ? cpaCanadaContent.modalEpStart.subHeader
              : cpaCanadaContent.modalLoggedIn.subHeader}
          </Typography>
          <Button
            label={
              isAnonymous
                ? cpaCanadaContent.modalEpStart.ctaBtnText
                : cpaCanadaContent.modalLoggedIn.ctaBtnText
            }
            skinny={false}
            sx={{ mt: 4, mb: 1 }}
            onClick={() => {
              AnalyticsService.buttonClick(
                isAnonymous
                  ? { name: CPA_BUTTON_NAME.SIGNUP_MODAL }
                  : { name: CPA_BUTTON_NAME.CONTENT_VERIFIABLE_MODAL },
              );

              if (isAnonymous) {
                window.open(
                  urls.appBase + cpaCanadaContent.modalEpStart.ctaLink,
                  '_self',
                );
              } else {
                window.open(cpaCanadaContent.modalLoggedIn.ctaLink, '_self');
              }
            }}
          />
          {isAnonymous && (
            <Box>
              <Typography variant="caption1">
                {cpaCanadaContent.modalEpStart.footer}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </AppModal>
  );
};
